import { render, staticRenderFns } from "./RepresentativeUser.vue?vue&type=template&id=23d391d9&"
import script from "./RepresentativeUser.vue?vue&type=script&lang=js&"
export * from "./RepresentativeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports